const Role = () =>
  import(/* webpackChunkName: "system" */ "@/app/admin/system/role/role");
const Backend = () =>
  import(/* webpackChunkName: "system" */ "@/app/admin/system/backend/index");
const IM = () =>
  import(/* webpackChunkName: "system" */ "@/app/admin/system/im/index");
  const AI = () =>
  import(/* webpackChunkName: "system" */ "@/app/admin/system/ai/aidemo");

export default [
  { path: "system", name: "system", redirect: "system/role" },
  {
    path: "system/aidemo",
    name: "ai",
    component: AI,
    meta: {
      title: "ai系统",
      key: "ai",
      permission: "system_setting.role_manager.btn_look_up"
    }
  },
  {
    path: "system/role",
    name: "role",
    component: Role,
    meta: {
      title: "角色管理",
      key: "role",
      permission: "system_setting.role_manager.btn_look_up"
    }
  },
  {
    path: "system/whitelist",
    name: "white",
    component: Backend,
    meta: {
      title: "白名单管理",
      key: "white",
      permission: "system_setting.ip_white_manager.btn_look_up"
    }
  },
  {
    path: "im",
    name: "im",
    component: IM,
    meta: {
      title: "群组管理",
      key: "im",
      permission: "im_manager.im_group_list.btn_look_up",
      // keepAlive: true
    }
  }
];
